import { LIST_CUSTOMER_METADATA_REQUEST } from './constants';

export const list = () => ({
  type: LIST_CUSTOMER_METADATA_REQUEST
});
